import React from 'react';
import { Link } from 'gatsby';
import cn from 'classnames';

import * as styles from './Button.module.css';

const Button = ({
  label,
  icon,
  to,
  href,
  onClick,
  className,
  disabled = false,
  inverted = false,
  ...otherProps
}) => {
  const _icon = icon ? <span className={styles.icon}>{icon}</span> : null;

  const cssClasses = cn(styles.root, className, {
    [styles.inverted]: inverted
  });
  if (to) {
    return (
      <Link to={to} className={cssClasses} {...otherProps}>
        {_icon}
        {label}
      </Link>
    );
  }
  if (href) {
    return (
      <a className={cssClasses} {...otherProps}>
        {_icon}
        {label}
      </a>
    );
  }
  return (
    <button
      className={cssClasses}
      onClick={onClick}
      disabled={disabled}
      {...otherProps}
    >
      {_icon}
      {label}
    </button>
  );
};

export default Button;
